import { withFullScreen } from '@/components/FullScreen';
import { ContributionSeasonality } from '@/dashboards/CampaignOptimization/components/ContributionSeasonality/ContributionSeasonality';
import { MediaSpendSeasonality } from '@/dashboards/CampaignOptimization/components/MediaSpendSeasonality';
import {
    Can,
    FEATURE_FLAG_ACTIONS,
    FEATURE_FLAG_SUBJECTS,
} from '@/features/Casl';
import React from 'react';

export const ContributionSeasonalitySection = withFullScreen(
    'contribution-seasonality',
    ({ fullScreenButton }) => {
        return (
            <div className="glass-tile p-6">
                <Can
                    I={FEATURE_FLAG_ACTIONS.VIEW}
                    a={
                        FEATURE_FLAG_SUBJECTS.CAMPAIGN_OPTIMIZATION_DASHBOARD_TOTAL_VS_MEDIA_INVESTMENT
                    }
                >
                    <ContributionSeasonality>
                        {fullScreenButton}
                    </ContributionSeasonality>
                </Can>

                <Can
                    I={FEATURE_FLAG_ACTIONS.VIEW}
                    a={
                        FEATURE_FLAG_SUBJECTS.CAMPAIGN_OPTIMIZATION_DASHBOARD_MEDIA_BUDGET_RECOMMENDATIONS
                    }
                >
                    <MediaSpendSeasonality />
                </Can>
            </div>
        );
    },
);
